import * as React from "react";
import "./style.css";
import Dialog from "material-ui/Dialog";
import TextField from "@material-ui/core/TextField";
import PosConsoleApi from "app/utils/PosConsoleApi";

type Props = {
  provider: string;
};

type State = {
  isVisible: boolean;
  testMobileNumber: string;
  testMessage: string;
};

export default class TestSmsProvider extends React.Component<Props, State> {
  state = {
    isVisible: false,
    testMobileNumber: "",
    testMessage: ""
  };

  sendMessage = () => {
    PosConsoleApi.post("text_messages/send_message", {
      message: this.state.testMessage,
      msisdn: this.state.testMobileNumber,
      provider: this.props.provider
    })
      .then(response => {
        response
          .json()
          .then(data => {
            if (response.status >= 300) {
              throw new Error(
                data.message
                  ? data.message
                  : "There was an error sending the text message. Please try again later."
              );
            }
          })
          .catch(error => {
            alert(error);
          });
      })
      .catch(error => {
        alert(error);
      })
      .then(() => {
        this.setState({
          isVisible: false,
          testMobileNumber: "",
          testMessage: ""
        });
      });
  };

  render() {
    const { isVisible, testMobileNumber, testMessage } = this.state;
    const { provider } = this.props;
    return (
      <>
        <button
          className="button no-margin testProviderButton"
          onClick={() => this.setState({ isVisible: true })}
        >
          Test Provider
        </button>

        <Dialog
          title={`Test Provider: ${provider}`}
          modal={false}
          open={isVisible}
          onRequestClose={() => this.setState({ isVisible: false })}
          actions={[
            <button
              className="button no-margin"
              disabled={!(testMobileNumber && testMessage)}
              onClick={this.sendMessage}
            >
              Send
            </button>
          ]}
        >
          <div className="testProviderContainer">
            <TextField
              fullWidth={false}
              label="Mobile Number"
              value={testMobileNumber}
              onChange={e =>
                this.setState({ testMobileNumber: e.target.value })
              }
            />
            <TextField
              fullWidth={false}
              label="Message"
              multiline={true}
              rows={2}
              value={testMessage}
              onChange={e => this.setState({ testMessage: e.target.value })}
            />
          </div>
        </Dialog>
      </>
    );
  }
}
